module.exports = __webpack_public_path__ + "img/hamburger.1f5e00b6.svg";